<template>
  <v-dialog v-model="isDialogVisible" max-width="400">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        Are you sure you want to proceed? This action cannot be undone.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text @click="confirm">Confirm</v-btn>
        <v-btn color="grey" text @click="cancel">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmationModal',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isDialogVisible: true, // Automatically show when component is used
    };
  },
  methods: {
    confirm() {
      this.$emit('confirmed'); // Emit an event to the parent for confirmation
      this.isDialogVisible = false;
    },
    cancel() {
      this.$emit('close'); // Emit an event to the parent to handle dialog closure
      this.isDialogVisible = false;
    },
  },
};
</script>
